module.exports = __webpack_public_path__ + "media/favicon/favicon-16x16-41e5e91264cc3bb67416ec8d757d5f39.png";